//
//  DocumentationLegacyPageUnorderedList.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlockText, } from "./SDKDocumentationLegacyPageBlockText";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageUnorderedList extends DocumentationLegacyPageBlockText {
}
